import React from 'react';
import AsyncSelect from "react-select/async";

import { SelectMenu, SelectCustomDropdown} from '../components';

interface ICustomAsyncSelect<T> {
    defaultOptions?: Array<T>,
    loadOptions: (data: string) => Promise<T[]>,
    customLabel?: string,
    customValue?: string,
    theme?: string,
    selected: T,
    CustomMenu?: any,
    changeHandler: (data: any) => void,
    borderLess?: boolean
}

const CustomAsyncSelect = <T extends {[key: string]: any}>({
    defaultOptions,
    loadOptions,
    customLabel = "label",
    customValue = "value",
    theme = "black",
    CustomMenu,
    selected,
    changeHandler,
    borderLess = false
}: ICustomAsyncSelect<T>) => {

    const asyncSelectHandler = function(inputValue: string, cb: (data: Array<T>) => any) {
        loadOptions(inputValue).then((res) => cb(res));
    };

    const label = (x: T) => x[customLabel as keyof typeof x];
    const value = (x: T) => x[customValue as keyof typeof x];

    return (
        <AsyncSelect 
            cacheOptions
            defaultOptions={defaultOptions}
            value={selected}
            components={{
                IndicatorSeparator: () => null,
                Menu: CustomMenu ? CustomMenu : SelectMenu as any,
                DropdownIndicator: SelectCustomDropdown,
            }}
            loadOptions={asyncSelectHandler}
            getOptionLabel={label}
            getOptionValue={value}
            onChange={changeHandler}
            styles={{
                //@ts-ignore
                control: (css) => ({
                    ...css,
                    backgroundColor: 'transparent',
                    width: '100%',
                    minWidth: '200px',
                    borderWidth: borderLess ? '0px' : '1px',
                    minHeight: '100%',
                    height: '100%',
                    borderColor: `${theme === 'white' ? 'rgb(203 213 225)' : ''}`
                }),
                //@ts-ignore
                input: (css) => ({
                    ...css,
                    color: `${theme === 'white' ? 'black' : '#CBD5E1'}`,
                    outline: 'none',
                }),
                //@ts-ignore
                singleValue: (css) => ({
                    ...css,
                    color: theme === 'white' ? 'rgb(30, 41, 59)' : '#CBD5E1',
                    marginRight: '0px',

                }),
                //@ts-ignore
                valueContainer: (provided, state) => ({
                    ...provided,
                    padding: '2px 0px 2px 8px',
                    fontSize: '14px',

                }),
                //@ts-ignore
                container: (css) => ({ ...css, width: '100%', height: '100%' }),
                //@ts-ignore
                menuList: (css) => ({
                    ...css,
                    overflow: "auto",
                    maxHeight: "160px",
                })
            }}
        />
    )
}

export default CustomAsyncSelect;